<template>
  <nav class="breadcrumbs">
    <div v-if="isInvestment" class="breadcrumbs__links">
      <!-- <router-link :to="`/`" class="breadcrumbs__link">Polska</router-link> -->
      <!-- <span class="breadcrumbs__space">></span> -->
      <span class="breadcrumbs__text"
        >{{ currentInvestment.investmentName }}
      </span>
    </div>
    <div v-if="isBuilding" class="breadcrumbs__links">
      <!-- <router-link :to="`/`" class="breadcrumbs__link">Polska</router-link> -->
      <!-- <span class="breadcrumbs__space">></span> -->
      <router-link
        :to="`/${currentInvestment.url}/building/${$route.params.building}`"
        class="breadcrumbs__link"
        >{{ currentInvestment.investmentName }}
      </router-link>
      <!-- TODO: Uncomment -->
      <!-- <span class="breadcrumbs__space" v-if="multiBuilding">></span>
      <span class="breadcrumbs__text" v-if="multiBuilding"
        >Budynek {{ $route.params.building.toUpperCase() }}
      </span> -->
    </div>
    <div v-if="isFloor" class="breadcrumbs__links">
      <!-- <router-link :to="`/`" class="breadcrumbs__link">Polska</router-link> -->
      <!-- <span class="breadcrumbs__space">></span> -->
      <router-link :to="`/${currentInvestment.url}`" class="breadcrumbs__link"
        >{{ currentInvestment.investmentName }}
      </router-link>
      <span class="breadcrumbs__space">></span>
      <router-link
        :to="`/${currentInvestment.url}/building/${$route.params.building}`"
        class="breadcrumbs__link"
        v-if="multiBuilding"
        >{{ $t('building') }} {{ $route.params.building.toUpperCase() }}
      </router-link>
      <span class="breadcrumbs__space" v-if="multiBuilding">></span>
      <span class="breadcrumbs__text"
        >{{ $t('floor') }} {{ $route.params.floor }}
      </span>
    </div>
    <div v-else-if="isFlat && flat" class="breadcrumbs__links">
      <!-- <router-link :to="`/`" class="breadcrumbs__link">Polska</router-link>
      <span class="breadcrumbs__space">></span> -->
      <router-link :to="`/${currentInvestment.url}`" class="breadcrumbs__link"
        >{{ currentInvestment.investmentName }}
      </router-link>
      <span class="breadcrumbs__space">></span>
      <router-link
        :to="
          `/${currentInvestment.url}/building/${
            flat[flatProperties['building']]
          }`
        "
        class="breadcrumbs__link"
        v-if="multiBuilding"
        >{{ $t('building') }}
        {{ flat[flatProperties['building']].toUpperCase() }}
      </router-link>
      <span class="breadcrumbs__space" v-if="multiBuilding">></span>
      <router-link
        v-if="multiBuilding"
        :to="
          `/${currentInvestment.url}/building/${
            flat[flatProperties['building']]
          }/floor/${flat[flatProperties['floor']]}`
        "
        class="breadcrumbs__link"
        >{{ $t('floor') }} {{ flat[flatProperties['floor']] }}
      </router-link>
      <router-link
        v-else
        :to="
          `/${currentInvestment.url}/building/${
            flat[flatProperties['building']]
          }/floor/${flat[flatProperties['floor']]}`
        "
        class="breadcrumbs__link"
        >{{ $t('floor') }} {{ flat[flatProperties['floor']] }}
      </router-link>
      <span class="breadcrumbs__space">></span>
      <span class="breadcrumbs__text"
        >{{ $t('flat') }} {{ $route.params.flat }}</span
      >
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'breadcrumbs',
  computed: {
    ...mapState({
      flatProperties: state => state.browser.flatProperties,
      currentInvestment: state => state.browser.currentInvestment,
    }),
    ...mapGetters({
      multiBuilding: 'IS_MULTI_BUILDING',
    }),
    estate() {
      if (this.currentInvestment) {
        return this.currentInvestment.investmentName;
      }
      return '';
    },
    isCountry() {
      return this.$route.name == 'country';
    },
    isInvestment() {
      return this.$route.name == 'investment';
    },
    isBuilding() {
      return this.$route.name == 'building';
    },
    isFloor() {
      return this.$route.name == 'floor';
    },
    isFlat() {
      return this.$route.name == 'flat';
    },
    isList() {
      return this.$route.name == 'list' || this.$route.name == 'listfloor';
    },
    isFavourite() {
      return this.$route.name == 'favourites';
    },
    flat() {
      return this.getFlat(this.$route.params.flat);
    },
  },
  methods: {
    ...mapMutations({
      toggleSidebar: 'TOGGLE_SIDEBAR',
    }),
    getFlat(id) {
      let flat = this.$store.getters.GET_FLATS_BY_PROPERTY(
        this.flatProperties['id'],
        id
      );
      if (flat) return flat[0];
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  width: auto;
  height: 50px;

  position: fixed;
  z-index: 30;
  top: $topbarHeight;
  left: 50%;
  transform: translateX(-50%);

  color: #000;
  @media screen and (max-width: $sm) {
    width: 100% !important;
  }
}
.breadcrumbs__links {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-width: 100%;

  padding: {
    left: 40px;
    right: 40px;
  }

  border-radius: 0 0 20px 20px;
  background: rgba($lighterGray, 0.57);
  box-shadow: 0 10px 20px rgba(#000, 0.08);
  text-align: center;
  font-weight: 400;
  font-size: 14px;

  @media screen and (max-width: $xs) {
    background: rgba(#fff, 0.9);
    font-size: 12px;
    padding: {
      left: 20px;
      right: 20px;
    }
  }
  @media screen and (max-width: $xxs) {
    font-size: 10px;
  }
}
.breadcrumbs__link,
.breadcrumbs__text {
  color: #000;
  text-decoration: none;
  @media screen and (min-width: $md) {
    white-space: nowrap;
  }
}

.breadcrumbs__space {
  margin: 0 8px;
}

.breadcrumbs__subtext {
  font-size: 14px;
  font-weight: 500;
  margin: {
    right: 6px;
  }
  @media screen and (max-width: $lg) {
    display: none;
  }
}
</style>
